export var slice = Array.prototype.slice;

export default function(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/array.js
// module id = 50
// module chunks = 0